import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  adminApiClientCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { adminEndpoints } from "@/features/admin/api/endpoints";

/**
 * Révoque un client API partenaire (`POST /ApiClients/{id}/revoke` —
 * endpoint gateway, §6.1). Action irréversible côté serveur : la clé cesse
 * d'être acceptée.
 */
export const useRevokeApiClient = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["admin", "api-clients", "revoke"],
    mutationFn: (apiClientId: string) =>
      mutateData({
        url: adminEndpoints.apiClients.revoke(apiClientId),
        method: "POST",
      }) as Promise<unknown>,
    onSuccess: (_data, apiClientId) => {
      return invalidateAfterMutation(
        queryClient,
        adminApiClientCacheKeys(apiClientId)
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useRevokeApiClient failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "admin" }
      );
    },
  });
};
